// extracted by mini-css-extract-plugin
module.exports = {"contactAndMoreBtn":"styles_contactAndMoreBtn__Wy2FL","popover":"styles_popover__VkgPU","popoverContents":"styles_popoverContents__ijNuy"};